// src/services/gatePassService.ts
import api from "../lib/api.ts";

export const downloadGatePassPdf = async (
  gatePassId: number
): Promise<Blob> => {
  const response = await api.get(
    `/gatepasses/buyer/${gatePassId}/pdf/download`,
    {
      responseType: "blob",
    }
  );
  return response.data;
};

export const streamGatePassPdf = async (gatePassId: number): Promise<Blob> => {
  const response = await api.get(`/gatepasses/buyer/${gatePassId}/pdf/stream`, {
    responseType: "blob",
  });
  return response.data;
};
